import React from "react";
import { connect, Provider } from "react-redux";
import * as actions from "../../actions/actions";
import store from "../../stores/reduxStore.js";

import Modal from "../../containers/modal";

const AboutVideoModalTriggerUnwrapped = ({ showModal }) => {
    const openModal = e => {
        showModal(e, "ABOUT_VIDEO_MODAL");
    };

    return (
        <span className="ui_animation video-link-container">
            <a href="#reveal-video" className="video-link" onClick={openModal}>
                Play the short video
            </a>
        </span>
    );
};

const ConnectedAboutVideoModalTrigger = connect(
    null,
    { showModal: actions.showModal }
)(AboutVideoModalTriggerUnwrapped);

export default function AboutVideoModalTrigger() {
    return (
        <Provider store={store}>
            <div>
                <ConnectedAboutVideoModalTrigger />
                <Modal />
            </div>
        </Provider>
    );
}
